import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Typography, Card, Descriptions, Tag, Spin } from "antd";
import moment from "moment";

import BackButton from "components/BackButton";
import "./styles.less";

const SystemNotificationDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [notification, setNotification] = useState(null);
  
  const notificationList = useSelector((state) => 
    state.systemNotification.notificationList
  );

  useEffect(() => {
    // Find the notification from the list by ID
    const foundNotification = notificationList.find(item => item._id === id);
    
    if (foundNotification) {
      setNotification(foundNotification);
    } else {
      // If not found in list, redirect back to list
      navigate("/system_notifications");
    }
  }, [id, notificationList, navigate]);


  if (!notification) {
    return (
      <div className="system-notification-detail-page">
        <Row className="system-notification-detail-header">
          <BackButton />
          <Typography.Title level={4}>Chi tiết thông báo hệ thống</Typography.Title>
        </Row>
        <div className="detail-content">
          <Card>
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Spin size="large" />
              <div style={{ marginTop: 16 }}>Đang tải dữ liệu...</div>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="system-notification-detail-page">
      <Row className="system-notification-detail-header">
        <BackButton backUrl="/system_notifications" />
        <Typography.Title level={4}>Chi tiết thông báo hệ thống</Typography.Title>
      </Row>
      
      <div className="detail-content">
        <Card>
          <Descriptions 
            title="Thông tin thông báo" 
            bordered 
            column={1}
            labelStyle={{ fontWeight: 500, width: "200px" }}
          >
            <Descriptions.Item label="Tiêu đề">
              <Typography.Text strong>
                {notification.title || notification.metaData?.title || "N/A"}
              </Typography.Text>
            </Descriptions.Item>
            
            <Descriptions.Item label="Nội dung">
              <div className="notification-message">
                {notification.message ? (
                  <div dangerouslySetInnerHTML={{ __html: notification.message }} />
                ) : (
                  <Typography.Text type="secondary">N/A</Typography.Text>
                )}
              </div>
            </Descriptions.Item>
            
            <Descriptions.Item label="Số người nhận được">
              <Tag color="orange" style={{ fontWeight: 500 }}>
                {notification.affectedUsers || 0} người
              </Tag>
            </Descriptions.Item>
            
            <Descriptions.Item label="SL thiết bị nhận thông báo">
              <Tag color="blue" style={{ fontWeight: 500 }}>
                {notification.numberOfDevices || 0} thiết bị
              </Tag>
            </Descriptions.Item>
            
            <Descriptions.Item label="Ngày tạo">
              <Typography.Text>
                {notification.createdAt 
                  ? moment(notification.createdAt).format("DD/MM/YYYY HH:mm:ss")
                  : "N/A"}
              </Typography.Text>
            </Descriptions.Item>
            
            {notification.updatedAt && (
              <Descriptions.Item label="Ngày cập nhật">
                <Typography.Text>
                  {moment(notification.updatedAt).format("DD/MM/YYYY HH:mm:ss")}
                </Typography.Text>
              </Descriptions.Item>
            )}
            
            {notification.type && (
              <Descriptions.Item label="Loại thông báo">
                <Tag color="blue">{notification.type}</Tag>
              </Descriptions.Item>
            )}
            
            {notification.priority && (
              <Descriptions.Item label="Độ ưu tiên">
                <Tag color={
                  notification.priority === "high" ? "red" :
                  notification.priority === "normal" ? "blue" :
                  "green"
                }>
                  {notification.priority === "high" ? "Cao" :
                   notification.priority === "normal" ? "Bình thường" :
                   "Thấp"}
                </Tag>
              </Descriptions.Item>
            )}
            
            {notification.status && (
              <Descriptions.Item label="Trạng thái">
                <Tag color={notification.status === "active" ? "green" : "red"}>
                  {notification.status === "active" ? "Đang hoạt động" : "Không hoạt động"}
                </Tag>
              </Descriptions.Item>
            )}
          </Descriptions>
        </Card>
      </div>
    </div>
  );
};

export default SystemNotificationDetail;